import React, { useState, Fragment } from 'react'
import { useLocation } from 'react-router-dom'

import EloHeader from 'ui/EloHeader'
import SectionTabs from 'ui/SectionTabs'
import WhiteWidget from 'ui/white-widget/WhiteWidget'
import { LoadingMask } from '@elo-kit/components/loading-mask/LoadingMask'

import { withStores } from 'utils/helpers.utils'

import HmacKeysDetails from './HmacKeysDetails'
import HmacKeysActions from './HmacKeysActions'

const HMAC_KEYS = {
  details: 'details',
}

const HMAC_KEYS_TABS = [
  {
    key: HMAC_KEYS.details,
    label: 'Details',
  },
]

const HmacKeysItem = (props) => {
  const { hmacKeysStore } = props
  const { hash: locationHash } = useLocation()
  const [activeTab, setActiveTab] = useState(HMAC_KEYS.details)

  const toggleActiveTab = (name) => setActiveTab(name)

  return (
    <Fragment>
      <EloHeader title='HMAC key' backUrl='/admin/hmac_keys' />
      <div className='content'>
        <WhiteWidget>
          <HmacKeysActions />
          <SectionTabs
            locationHash={locationHash}
            tabs={HMAC_KEYS_TABS}
            activeTab={activeTab}
            setActiveTab={toggleActiveTab}
            withHash
          />
          <HmacKeysDetails />
        </WhiteWidget>
      </div>
      {hmacKeysStore.loading && <LoadingMask />}
    </Fragment>
  )
}

export default withStores(['hmacKeysStore'], HmacKeysItem)
